import { FaFacebookF, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import styled from "styled-components";

import { FiMessageSquare, FiTwitter } from "react-icons/fi";
type Props = {
  title: string;
  shareUrl: string;
  size?: number;
};
const cons = "const";
const ShareButtonsBar = ({ title, shareUrl, size = 32 }: Props) => {
  return (
    <ShareButtonsBarWrapper className="d-flex justify-content-center" dir="ltr">
      <FacebookShareButton
        url={shareUrl}
        quote={title}
        resetButtonStyle={false}
        style={{ height: 46, width: 46 }}
        className="btn btn-secondary btn-icon rounded-2 border-0 bg-none bg-secondar ms-2"
      >
        <FaFacebookF size={size} />
      </FacebookShareButton>
      <EmailShareButton
        url={shareUrl}
        resetButtonStyle={false}
        style={{ height: 46, width: 46 }}
        className="btn btn-secondary btn-icon rounded-2 border-0 bg-none bg-secondar ms-2"
      >
        <FiMessageSquare size={size} />
      </EmailShareButton>
      <TwitterShareButton
        url={shareUrl}
        style={{ height: 46, width: 46 }}
        resetButtonStyle={false}
        className="btn btn-secondary btn-icon rounded-2 border-0 bg-none bg-secondar ms-2"
      >
        <FiTwitter size={size} />
      </TwitterShareButton>
      <WhatsappShareButton
        style={{ height: 46, width: 46 }}
        url={shareUrl}
        resetButtonStyle={false}
        className="btn btn-secondary btn-icon rounded-2 border-0 bg-none bg-secondar ms-2"
      >
        <FaWhatsapp size={size + 4} />
      </WhatsappShareButton>
      <TelegramShareButton
        url={shareUrl}
        style={{ height: 46, width: 46 }}
        resetButtonStyle={false}
        className="btn btn-secondary btn-icon rounded-2 border-0 bg-none bg-secondar ms-2"
      >
        <FaTelegramPlane size={size} />
      </TelegramShareButton>
    </ShareButtonsBarWrapper>
  );
};

export default ShareButtonsBar;
const ShareButtonsBarWrapper = styled.div`
  button {
    /* margin-right: 10px; */
  }
`;
